<div class="app-shell">
  <div class="app-header">
    <h1 class="app-title">
      <img src="assets/images/Chevron_Logo 3.png" alt="Chevron" class="app-logo" />
      Notification Agent
    </h1>
    <div class="header-user" *ngIf="userName">
      <span class="user-name">{{ userName }}</span>
      <img *ngIf="showPhoto" class="user-photo" [src]="userPhoto" (error)="showPhoto = false" [alt]="userName"
        title="{{ userName }}" />
      <span *ngIf="!showPhoto" class="user-initials" [title]="userName">{{ userInitials }}</span>
    </div>
  </div>

  <div class="layout">
    <div class="sidebar-col">
      <app-conversation-sidebar></app-conversation-sidebar>
    </div>
    <div class="left-col">
      <app-chat></app-chat>
    </div>
    <div class="right-col">
      <app-campaign-form></app-campaign-form>
    </div>
  </div>
</div>